import { PayoutApiClient } from '@fourthwall/services/dist/PayoutApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useStartStripeOnboardingMutation = createMutationHook(
  PayoutApiClient.startStripeOnboarding,
  {
    mutationKey: ['startStripeOnboarding'],
  },
)
